import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'lg' | 'md';
  className?: string;
};
export function CtaButton({
  children,
  href = '#precios',
  size = 'lg',
  className = ''
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-5 text-base sm:text-lg' : 'px-6 py-4 text-sm sm:text-base';
  return <a href={href} className={`group inline-flex w-full items-center justify-center gap-3 rounded-xl bg-flame font-display font-extrabold uppercase tracking-wide text-white shadow-[0_10px_0_0_#b62f21] transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-[#ea4a37] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-flame active:translate-y-1 active:shadow-[0_4px_0_0_#b62f21] ${sizing} ${className}`} data-id="element-49" data-mp="qjijzrq25021">
      <span className="text-center leading-tight" data-id="element-50" data-mp="15arfghgn5fn3">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-51" data-mp="35xo0oxojy8ky" />
    </a>;
}